import { YouthAndSportNumber } from '../../lib/types/models/youth-and-sport-number/youth-and-sport-number'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getYouthAndSportNumber(id: number) {
  return restApiClient
    .url(constructApiUrl(API.youthAndSportNumbers.get.url, { id }))
    .get<YouthAndSportNumber>()
}
